// Unauth view Login form
import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { contains } from 'ramda';
import { withRouter } from 'react-router';

// Redux
import { connect } from 'react-redux';
import {
  closeConfirmDialog,
  openConfirmDialog,
} from '../../../../actions/dialog/dialogActions';
import { loginRequest } from '../../../../actions/session/sessionActions';
import * as SessionTypes from '../../../../actions/session/types';
import { forgotUsername } from '../../../../actions/username/usernameActions';
import { forgotPassword } from '../../../../actions/password/passwordActions';
import { hideFullPageLoadingState, showFullPageLoadingState } from '../../../../actions/loadingState/loadingStateActions';

import LoadingState from '../../../LoadingState';
import { setLoggedIn } from '../../../../lib/auth';

import ForgotUsernameDialog from '../ForgotUsernameDialog/ForgotUsernameDialog';
import ForgotPasswordDialog from '../ForgotPasswordDialog/ForgotPasswordDialog';

// Page styles
import cx from 'classnames';
import s from './LoginForm.css';


// LoginForm is independent of a redux connected LandingPage. It's like David Pumpkins, "it's own thaaaang."
export class LoginForm extends Component {
  static propTypes = {
    closeConfirmDialog: func,
    forgotPassword: func,
    forgotUsername: func,
    hideFullPageLoadingState: func,
    loadingState: object,
    location: object,
    loginRequest: func,
    history: object,
    match: object,
    openConfirmDialog: func,
    showFullPageLoadingState: func,
  };

  constructor(props) {
    super(props);

    this.state = {
      disabled: true,
      errorMessage: '',
      password: '',
    };
  }

  // This method is invoked before every change to component - either props change
  // or state change. Here, you can validate your form data and set flag you need - all in one place.
  componentWillUpdate(nextProps, nextState) {
    nextState.disabled = !(nextState.username && nextState.password);
  }

  isLoadingLoginRequest = loadingState => contains(SessionTypes.LOGIN_REQUEST, loadingState.requests);

  handleSubmit = (e) => {
    e.preventDefault();

    // Build the login request object
    const request = JSON.stringify({
      username: this.refs.username.value,
      password: this.refs.password.value,
    });

    // Execute the login request and handle the response accordingly
    this.props.loginRequest(
      request,
      this.successCallback,
      this.errorCallback,
    );
  };

  successCallback = response => {
    const route = response.route;
    setLoggedIn(route, response.logoutUrl);

    /**
     * Successful responses return a route (home, resetpassword, etc.) indicating
     * where to transition the end user to based on a calculated session state
     * from the server side.
     */
    this.props.router.replace(`/${route}`);
  };

  errorCallback = response => {
    /**
     * Extract the error message from the failed response and
     * display it to the end user.
     */
    this.setState({
      errorMessage: response.message.body,
      password: '',
    });
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  };

  render = () => {
    const { loadingState } = this.props;
    const isLoadingLoginRequest = this.isLoadingLoginRequest(loadingState);

    return (
      <section className={s.component} id="loginFormComponent">
        <h3 className={s.header}>
          Login
        </h3>
        <form
          id="loginForm"
          className={s.form}
          onSubmit={this.handleSubmit}
          method="post"
        >
          <div className={s.groupStacked}>
            <label className={s.label} htmlFor="username">
              Username
            </label>
            <input
              type="text"
              ref="username"
              name="username"
              id="username"
              autoCorrect="off"
              autoCapitalize="none"
              required
              className={s.control}
              onChange={this.handleInputChange}
            />
          </div>
          <div className={s.groupStacked}>
            <label className={s.label} htmlFor="password">
              Password
            </label>
            <input
              type="password"
              ref="password"
              name="password"
              id="password"
              required
              value={this.state.password}
              className={s.control}
              onChange={this.handleInputChange}
            />
          </div>
          <div className={s.groupStacked}>
            <ForgotUsernameDialog
              closeConfirmDialog={this.props.closeConfirmDialog}
              handleForgotUsername={this.props.forgotUsername}
              hideFullPageLoadingState={this.props.hideFullPageLoadingState}
              openConfirmDialog={this.props.openConfirmDialog}
              showFullPageLoadingState={this.props.showFullPageLoadingState}
            />
          </div>
          <div className={s.groupStacked}>
            <ForgotPasswordDialog
              closeConfirmDialog={this.props.closeConfirmDialog}
              handleForgotPassword={this.props.forgotPassword}
              hideFullPageLoadingState={this.props.hideFullPageLoadingState}
              openConfirmDialog={this.props.openConfirmDialog}
              showFullPageLoadingState={this.props.showFullPageLoadingState}
            />
          </div>
          <div className={cx(s.group, s.margins)}>
            <button
              type="submit"
              className={s.btn}
              disabled={this.state.disabled || isLoadingLoginRequest}
            >
              {isLoadingLoginRequest ? (
                <LoadingState context="loginForm" />
              ) : (
                'Login'
              )}
            </button>
          </div>
          {this.state.errorMessage &&
            <p className={s.message}>
              {this.state.errorMessage}
            </p>
          }
        </form>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  loadingState: state.loadingState,
});

const mapDispatchToProps = dispatch => ({
  closeConfirmDialog: () => dispatch(closeConfirmDialog()),
  loginRequest: (request, successCb, errorCb) => dispatch(loginRequest(request, successCb, errorCb)),
  forgotPassword: (username, successCb, errorCb) => dispatch(forgotPassword(username, successCb, errorCb)),
  forgotUsername: (email, successCb, errorCb) => dispatch(forgotUsername(email, successCb, errorCb)),
  hideFullPageLoadingState: () => dispatch(hideFullPageLoadingState()),
  openConfirmDialog: dialog => dispatch(openConfirmDialog(dialog)),
  showFullPageLoadingState: () => dispatch(showFullPageLoadingState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginForm));



// WEBPACK FOOTER //
// ./src/components/Pages/Login/LoginForm/LoginForm.js